import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import './Header.css';
import { useIsMobile } from '../utils/utils';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const isHome = location.pathname === '/';

  const goHome = () => navigate('/');

  return (
    <div className="header-root">
      <div
        onClick={isHome && !isMobile ? undefined : goHome}
        className={`header-title-container ${!isMobile ? 'header-title-container-desktop' : ''}`}
        role={isHome && !isMobile ? undefined : 'button'}
        tabIndex={isHome && !isMobile ? -1 : 0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            goHome();
          }
        }}
      >
        {!isHome || isMobile ? (
          <h1 className="header-title mobile-header">alice fleerackers</h1>
        ) : null}
      </div>
      <div className="header-action-container">
        <Navigation />
      </div>
    </div>
  );
}
